import axios from "axios";
import { Constants } from "../utils/Constants";

export function login(email, password, captchaToken) {
  return axios.post(
    `${Constants.url}/api/auth/login`,
    { email, password, captchaToken },
    { _isAuthRoute: true }
  );
}

export function me() {
  return axios.get(`${Constants.url}/api/auth/me`, { _isAuthRoute: true });
}

export function refresh() {
  return axios.post(`${Constants.url}/api/auth/refresh`, null, {
    _isAuthRoute: true,
  });
}

export function redeemTransfer(transferToken) {
  return axios.post(
    `${Constants.url}/api/auth/transfer/redeem`,
    { transfer_token: transferToken },
    { _isAuthRoute: true }
  );
}

export function createTransfer(targetCtx) {
  return axios.post(
    `${Constants.url}/api/auth/transfer`,
    { target_ctx: targetCtx },
    { _isAuthRoute: true }
  );
}

export function logout() {
  return axios.post(`${Constants.url}/api/auth/logout`, null, {
    _isAuthRoute: true,
  });
}

export function verifyMfaLogin(sid, code) {
  return axios.post(
    `${Constants.url}/api/auth/mfa/verify`,
    { sid, code },
    { _isAuthRoute: true }
  );
}

export function getMfaStatus() {
  return axios.get(`${Constants.url}/api/auth/mfa/status`);
}

export function setupMfa() {
  return axios.post(`${Constants.url}/api/auth/mfa/setup`);
}

export function enableMfa(code) {
  return axios.post(`${Constants.url}/api/auth/mfa/enable`, { code });
}

export function disableMfa(password) {
  return axios.post(`${Constants.url}/api/auth/mfa/disable`, { password });
}

export function forgot(email, captchaToken) {
  return axios.post(`${Constants.url}/api/auth/password/forgot`, {
    email,
    captchaToken,
  });
}

export function reset(token, password) {
  return axios.post(`${Constants.url}/api/auth/password/reset`, {
    token,
    password,
  });
}

export function changePassword(currentPassword, newPassword) {
  return axios.post(`${Constants.url}/api/auth/password/change`, {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

export function getSessions() {
  return axios.get(`${Constants.url}/api/auth/sessions`);
}

export function revokeSession(sessionId) {
  return axios.delete(`${Constants.url}/api/auth/sessions/${sessionId}`);
}

export function revokeAllOtherSessions() {
  return axios.delete(`${Constants.url}/api/auth/sessions`);
}

export function regenerateBackupCodes(password) {
  return axios.post(`${Constants.url}/api/auth/mfa/backup-codes/regenerate`, {
    password,
  });
}

export function getMfaMethods(sid) {
  const params = sid ? `?sid=${sid}` : "";
  return axios.get(`${Constants.url}/api/auth/mfa/methods${params}`);
}

export function verifyStepUp(code, bucket = "security") {
  return axios.post(`${Constants.url}/api/auth/mfa/step-up/verify`, {
    code,
    bucket,
  });
}

export function forceResetPassword(userId, password) {
  return axios.post(`${Constants.url}/api/auth/password/force-reset/${userId}`, {
    password,
  });
}

export function requestMfaRecovery(sid) {
  return axios.post(
    `${Constants.url}/api/auth/mfa/recovery/request`,
    { sid },
    { _isAuthRoute: true }
  );
}

export function setupMfaRecovery(token) {
  return axios.post(
    `${Constants.url}/api/auth/mfa/recovery/setup`,
    { token },
    { _isAuthRoute: true }
  );
}

export function completeMfaRecovery(token, code) {
  return axios.post(
    `${Constants.url}/api/auth/mfa/recovery/complete`,
    { token, code },
    { _isAuthRoute: true }
  );
}
